// src/components/homzready/HomzReadyPulseLoader.jsx
import React from "react";
import logoIcon from "../../assets/homzready/logo-icon.png";

/**
 * HomzReadyPulseLoader
 * - Lightweight pulse loader using Tailwind's animate-pulse (opacity in/out)
 * - Reusable everywhere: Suspense fallback, full-screen overlay, inline, etc.
 *
 * Props:
 *  - size?: number (px) default 80
 *  - label?: string (aria text) default "Loading…"
 *  - className?: string (extra classes)
 *  - inline?: boolean (if true, no overlay styles applied – just the pulsing logo)
 */
export default function HomzReadyPulseLoader({
  size = 80,
  label = "Loading…",
  className = "",
  inline = false,
}) {
  const imgEl = (
    <img
      src={logoIcon}
      alt="HomzReady"
      width={size}
      height={size}
      className={`animate-pulse select-none rounded-xl shadow-sm ${className}`}
      draggable={false}
    />
  );

  if (inline) {
    // simple inline usage
    return (
      <div className="inline-flex items-center justify-center gap-2" role="status" aria-live="polite">
        {imgEl}
        <span className="sr-only">{label}</span>
      </div>
    );
  }

  // full-screen overlay usage (centered)
  return (
    <div
      className="fixed inset-0 z-[60] bg-white/70 backdrop-blur-[1px] flex items-center justify-center"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      {imgEl}
      <span className="sr-only">{label}</span>
    </div>
  );
}
